import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS, postData } from '../constants/api';
import { CURRENT_DATE } from '../constants';
import '../css/modal.css';
import '../css/autocomplete.css';
import { decodeToken, getToken } from '../utils/TokenUtils';
import { useTranslation } from 'react-i18next';
import { App, notification } from 'antd';
import {
  fetchForm,
  fetchSuggestions,
  loadDropdown,
  loadInfo,
} from '../utils/ktcUtils';
import {useNavigate} from 'react-router-dom'
import { useHvStateContext } from '../context/HorizontalFormContext';
const ReceiptForm = ({
  userId,
  token,
  route,
  queryParams,
  isOpen,
  onRequestClose,
}) => {
  const { t } = useTranslation();
  let queryObj = {};
  // console.log('queryParms:', queryParams);

  if (queryParams) {
    const params = new URLSearchParams(queryParams);
    queryObj = Object.fromEntries(params.entries());
  }
  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);
  const [initialValues, setInitialValues] = useState([]);
  const [progress, setProgress] = useState(0);

  const [message, setMessage] = useState([]);
  const [queries, setQueries] = useState('');

  const branchId = decodeToken(token, 'branch_id');
  const userlevel = decodeToken(token, 'userLevel');

  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState([]);
  const [balanceInfo,setBalanceInfo]=useState([]);
  const navigate = useNavigate();
  const { hvInputsValues, setHvInputsValues } = useHvStateContext();
  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform/${route}`;
    fetchForm({
      url,
      queryObj,
      setLink,
      setInputs,
      setValues,
      setLoading,
      isModal:true
    });
  }, [route]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    //console.log(name, value, type, checked );
    setValues((prevValues) => {
      // update the changed field first
      const newValues = {
        ...prevValues,
        [name]: type === 'checkbox' ? checked : value,
      };
      let updated = true;
      while (updated) {
        updated = false;

        inputs.forEach((inp) => {
          if (inp.options && inp.options.includes('=')) {
            const [target, expression] = inp.options.split('=');

            // 🛠 Replace variables with values, respecting min_value before eval
            const expr = expression.replace(/\b[a-zA-Z_]\w*\b/g, (match) => {
              let val = newValues[match] ?? 0;

              // If that input has a min_value, clamp it
              const inputMeta = inputs.find((i) => i.name === match);
              if (
                inputMeta &&
                inputMeta.type === 'number' &&
                inputMeta.min_value !== undefined &&
                Number(inputMeta.min_value) > 0
              ) {
                val = Math.max(val, Number(inputMeta.min_value));
              }

              return val;
            });

            try {
              const result = eval(expr) > 0 ? eval(expr) : 0;
              if (newValues[target] !== result) {
                newValues[target] = result;
                updated = true;
              }
            } catch (err) {
              console.warn(
                `Error evaluating formula for ${inp.name}:`,
                expression,
                err
              );
            }
          }
        });
      }

      inputs.forEach((inp) => {
        if (
          inp.type === 'number' &&
          inp.min_value !== undefined &&
          Number(inp.min_value) > 0
        ) {
          const currentVal = Number(newValues[inp.name] ?? 0);
          const minVal = Number(inp.min_value);
          if (currentVal < minVal) {
            newValues[inp.name] = minVal;
          }
        }
      });

      return newValues;
    });

// console.log(" ")
    // 
  };

  useEffect(()=>{
    const url2=`${API_URL}/${ENDPOINTS.SYS}/reportCustom/get-balance-info`
    const fetchBalanceInfo=async ()=>{
    const res=await postData(url2,{std_id:values.id,fee_id:values.fee_id || '%'});
    setBalanceInfo(res.data || []); 
  if (values.month!='') {
    let total=0;
    res?.data?.forEach(data => {
     
      if (values.month.includes(data.month) && values.year===data.year) {
        total=total+Number(data.balance)
      }
    });
    let discount=Number(values?.discount) || 0;
    total=total-discount;
     setValues(prev=>(
      {...prev,
        amount:total
      }
     ))

  }

    }
    if (values?.id>0 && values.fee_id>0 && values.month!='' && values.year!=''){ 
      fetchBalanceInfo();
    }else{
      setValues(prev=>(
      {...prev,
        amount:0
      }
     ))
    }
  },[values.fee_id,values.id,values.month,values.year,values?.discount])

  const handleLoadDropdownChange = async (e, input) => {
    const { name, value, type, checked } = e.target;
    console.log(name, value, type, checked);
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    await loadDropdown(
      value, // The event (e.g., from onChange)
      input, // The full input object
      setLoading,
      setValues,
      setInputs
    );
  };

  const handleAutocompleteChange = async (e, inputId) => {
    const { name, value, type, checked } = e.target;

    setQueries((prev) => ({ ...prev, [inputId]: value }));

    fetchSuggestions(value, inputId);
  };

  // Function to fetch suggestions from the server
  const fetchSuggestions = async (query, inputId) => {
    if (!query) {
      setSuggestions((prev) => ({ ...prev, [inputId]: [] }));
      return;
    }
    try {
      setLoading(true);
      const url = `${API_URL}/${ENDPOINTS.SYS}/autocomplete-v2/${inputId}?query=${query}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
      setResponse(response.data); // Update suggestions from server response
      setSuggestions((prev) => ({ ...prev, [inputId]: response.data.results }));
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSetClickedValue = async (input, suggestion) => {
    setValues((prevValues) => ({
      ...prevValues,
      [input.name]: suggestion.id,
    }));

    setQueries((prev) => ({ ...prev, [input.id]: suggestion.name }));
    setSuggestions((prev) => ({ ...prev, [input.id]: [] }));
    try {
      await loadDropdown(
        suggestion.id,
        input,
        setLoading,
        setValues,
        setInputs
      );
    } catch (err) {
      notification.error({ message: err.message });
    }
    try {
      await loadInfo(response, input, suggestion, setInputs, setValues);
    } catch (err) {
      notification.error({ message: err.message });
    }
  };
  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0]; // Get the selected file

    setValues((prev) => ({
      ...prev,
      [name]: file, // Dynamically set the file input field by name
    }));
  };

  const handleMultiFileChange = (e) => {
    const { name } = e.target;
    const files = Array.from(e.target.files); // Convert FileList to array

    setValues((prev) => ({
      ...prev,
      [name]: files, // Store array of files for the input field
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setProgress(0);

    // Create a copy of formData without the clearAfterSubmit field
    const { clearAfterSubmit, ...values2 } = values;

    try {
      const route2 = route.replace(/^\s+|\s+$/g, ''); // Trims leading and trailing spaces
      //  console.log('route: "', route, '", route2: "', route2, '"');
      var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/${route}`;
      if (
        link.api_route &&
        link.api_route !== '' &&
        link.api_route.trim() !== ''
      ) {
        insertUrl = `${API_URL}/${link.api_route}`;
      } else if (
        link.form_type === 'reg-upload-modal' &&
        link.sql_query &&
        link.sql_query.trim() !== ''
      ) {
        insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create-upload-custom/${route}`;
      } else if (link.form_type === 'reg-upload-modal') {
        insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create-upload/${route}`;
      }
      const data = new FormData();
      Object.keys(values2).forEach((key) => {
        const value = values2[key];

        if (Array.isArray(value)) {
          value.forEach((file) => {
            data.append(key, file); // ✅ No square brackets
          });
        } else {
          data.append(key, value);
        }
      });

      try {
        // console.log('values2:', values2);
        var response;
        if (link.form_type === 'reg-upload-modal') {
          if (userlevel === 'developer') {
            console.log('data:', data.entries());
          }

          response = await axios.post(insertUrl, data, {
            headers: {
              'Content-Type': 'multipart/form-data', // Required for FormData
              Authorization: token ? `Bearer ${token}` : '',
            },
            onUploadProgress: (progressEvent) => {
              const percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setProgress(percent);
            },
          });
          if (userlevel === 'developer') {
            console.log('res:', response);
          }
          //  console.log();
        } else {
          response = await axios.post(insertUrl, values2, {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          });
        }
        // print console url, request and response

        if (userlevel === 'developer') {
          console.log(
            'url:',
            insertUrl,
            'request:',
            values2,
            'reponse:',
            response.data
          );
        }
        setMessage(response.data);
        setLoading(false);
        setProgress(0);

        if (response.data.success === '1' || response.data.success === 1) {
          notification.success({ message: response.data.message });

          // Clear form only if checkbox is checked
          if (clearAfterSubmit) {
            setValues(initialValues);
          }
          if (response.data.insertId && response.data.print_route) {
            console.log('Show success & print button');
            const url = `/${response.data.print_route}/${response.data.insertId}`;
            window.open(url, "_blank");
          }
           else {
            if(link.auto_submit==='1' || link.auto_submit===1){
               onRequestClose(); // Close modal after submission
            }
          }
        }

        // onRequestClose(); // Close modal after submission
      } catch (error) {
        alert(`An error occurred ${error.message}`);
        // console.log('error:', error, 'insertUrl:',insertUrl, 'values:', values);
        setLoading(false);
        setProgress(0);
      }
    } catch (error) {
      alert(`An error occurred ${error.message}`);
      setLoading(false);
      setProgress(0);
    }
  };

  return (
    <div
      className={`modal fade ${isOpen ? 'show' : ''}`}
      style={{ display: isOpen ? 'block' : 'none' }}
      tabIndex="-1"
      aria-hidden={isOpen ? 'false' : 'true'}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content  ">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">
              {link?.name}
              <small>
                {' '}
                {link?.category} - {link?.sub_category}
              </small>
            </h5>

            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onRequestClose}
            ></button>
          </div>
          <div className="modal-body  ">
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="row">
                {inputs &&
                  inputs.map((input) => {
                    const options =
                      input.options
                        ?.split(',')
                        .map((option) => option.trim()) || [];

                    return (
                      <div
                        className={`mb-3 col-${input.size} ${input.type.includes('hidden') ? 'd-none' : ''}`}
                        key={input.name}
                      >
                        {input.type !== 'hidden-user' &&
                          input.type !== 'hidden' &&
                          input.type !== 'hidden-branch' && (
                            <>
                              <label
                                htmlFor={input.name}
                                className="form-label text-capitalize font-weight-bold text-start"
                                style={{ textAlign: 'left !important' }}
                              >
                                {/* {input.label}:{' '} */}
                                {t(input.label)}:{' '}
                                {input.is_required !== 0 && (
                                  <>
                                    <span
                                      className="text-danger"
                                      title={`'${input.label}' field is required, please fill it before submit the form`}
                                    >
                                      {' '}
                                      *
                                    </span>
                                    {input.description && (
                                      <span
                                        className=""
                                        style={{
                                          backgroundColor: 'red',
                                          color: 'white',
                                          borderRadius: '30%',
                                        }}
                                        title={`${input.description} ${input.help}`}
                                      >
                                        ?
                                      </span>
                                    )}
                                  </>
                                )}
                              </label>{' '}
                              &nbsp;&nbsp;
                            </>
                          )}
                        {(() => {
                          switch (input.type) {
                            case 'radio':
                              return (
                                input.dynamic_options &&
                                input.dynamic_options.map((option, index) => (
                                  <div
                                    className="form-check form-check-inline"
                                    key={index}
                                  >
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id={`${input.name}-${index}`}
                                      name={input.name}
                                      value={option.id}
                                      checked={values[input.name] === option.id}
                                      onChange={handleChange}
                                    />
                                    <label
                                      htmlFor={`${input.name}-${index}`}
                                      className="form-check-label"
                                    >
                                      {option.name}
                                    </label>
                                  </div>
                                ))
                              );

                            case 'dropdown':
                              return (
                                <select
                                  className="form-select"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                >
                                  <option value="" >
                                    Select an option
                                  </option>

                                  {input.dynamic_options &&
                                    input.dynamic_options.map(
                                      (option, index) => {
                                        const optionKeys = Object.keys(option);
                                        const firstValue =
                                          option[optionKeys[0]] || 'No Value 1';
                                        const secondValue =
                                          option[optionKeys[1]] || 'No Value 2';

                                        return (
                                          <option
                                            key={index}
                                            value={firstValue}
                                          >
                                            {secondValue}
                                          </option>
                                        );
                                      }
                                    )}
                                </select>
                              );
                            case 'group-dropdown':
                              return (
                                <select
                                  className="form-select"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                >
                                  <option value="" disabled>
                                    Select an option
                                  </option>
                                  {input.dynamic_options &&
                                    Object.entries(
                                      input.dynamic_options.reduce(
                                        (groups, option) => {
                                          // Group options by the 'group' key
                                          if (!groups[option.group])
                                            groups[option.group] = [];
                                          groups[option.group].push(option);
                                          return groups;
                                        },
                                        {}
                                      )
                                    ).map(([group, options]) => (
                                      <optgroup key={group} label={group}>
                                        {options.map((option) => (
                                          <option
                                            key={option.id}
                                            value={option.id}
                                          >
                                            {option.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                    ))}
                                </select>
                              );

                            case 'load-dropdown':
                              return (
                                <select
                                  className="form-select"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={(e) =>
                                    handleLoadDropdownChange(e, input)
                                  }
                                  required={input.is_required}
                                >
                                  <option value="%">Select all</option>
                                  {input.dynamic_options?.map(
                                    (option, index) => (
                                      <option key={index} value={option.id}>
                                        {option.name}
                                      </option>
                                    )
                                  )}
                                </select>
                              );

                            case 'load-dropdown2':
                              return (
                                <select
                                  className="form-select"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={(e) =>
                                    handleLoadDropdownChange(e, input)
                                  }
                                  required={input.is_required}
                                >
                                  <option value="%">Select all</option>
                                  {input.dynamic_options?.map(
                                    (option, index) => (
                                      <option key={index} value={option.id}>
                                        {option.name}
                                      </option>
                                    )
                                  )}
                                </select>
                              );
                            case 'load-input':
                              return (
                                <select
                                  className="form-select"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={(e) =>
                                    handleLoadDropdownChange(e, input)
                                  }
                                  required={input.is_required}
                                >
                                  <option value="%">Select all</option>
                                  {input.dynamic_options?.map(
                                    (option, index) => (
                                      <option key={index} value={option.id}>
                                        {option.name}
                                      </option>
                                    )
                                  )}
                                </select>
                              );

                            case 'autocomplete':
                              return (
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className="form-control" // Bootstrap class for styling
                                    // value={query}
                                    value={queries[input.id] || ''}
                                    onChange={(e) =>
                                      handleAutocompleteChange(e, input.id)
                                    }
                                    placeholder="Search..."
                                    style={{
                                      width: '100%', // Ensure it matches the container width
                                    }}
                                  />
                                  {loading && <div>Loading...</div>}
                                  {suggestions[input.id]?.length > 0 && (
                                    <ul
                                      className="list-group position-absolute"
                                      style={{
                                        margin: 0,
                                        top: '100%',
                                        width: '100%',
                                        zIndex: 1,
                                        maxHeight: '200px', // Limit height
                                        overflowY: 'auto', // Add vertical scroll
                                        border: '1px solid #ccc', // Add border for better visibility
                                        borderRadius: '4px',
                                        backgroundColor: '#fff',
                                      }}
                                    >
                                      {suggestions[input.id].map(
                                        (suggestion, index) => (
                                          <li
                                            className="list-group-item"
                                            key={index}
                                            onClick={() => {
                                              handleSetClickedValue(
                                                input,
                                                suggestion
                                              ); 
                                            }}
                                            style={{
                                              padding: '8px',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {suggestion.name}
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  )}
                                </div>
                              );

                            case 'enum':
                              return (
                                options &&
                                options.map((option, index) => (
                                  <div
                                    className="form-check form-check-inline"
                                    key={index}
                                  >
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id={`${input.name}-${index}`}
                                      name={input.name}
                                      value={option}
                                      checked={values[input.name] === option}
                                      onChange={handleChange}
                                    />
                                    <label
                                      htmlFor={`${input.name}-${index}`}
                                      className="form-check-label"
                                    >
                                      {option}
                                    </label>
                                  </div>
                                ))
                              );
                            case 'enum-checkbox':
                              return options?.map((option, index) => (
                                <div className="form-check" key={index}>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`${input.name}-${index}`}
                                    name={input.name}
                                    value={option}
                                    checked={values[input.name]?.includes(
                                      option
                                    )}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      const currentValues =
                                        values[input.name] || [];
                                      const updatedValues = isChecked
                                        ? [...currentValues, option]
                                        : currentValues.filter(
                                            (val) => val !== option
                                          );

                                      handleChange({
                                        target: {
                                          name: input.name,
                                          value: updatedValues,
                                        },
                                      });
                                    }}
                                  />
                                  <label
                                    htmlFor={`${input.name}-${index}`}
                                    className="form-check-label"
                                  >
                                    {option}
                                  </label>
                                </div>
                              ));

                            case 'enum-dropdown':
                              return (
                                <select
                                  className="form-select"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                >
                                  <option value="" disabled>
                                    Select an option
                                  </option>
                                  {options &&
                                    options.map((option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                </select>
                              );

                            case 'checkbox':
  return (
    <>
      {input.dynamic_options?.length > 0 && (
        <div className="form-check mb-2">
          <input
            type="checkbox"
            className="form-check-input"
            id={`${input.name}-check-all`}
            checked={
              values[input.name]?.length === input.dynamic_options.length
            }
            onChange={(e) => {
              const isChecked = e.target.checked;
              const allIds = input.dynamic_options.map((opt) => opt.id);

              handleChange({
                target: {
                  name: input.name,
                  value: isChecked ? allIds : [],
                },
              });
            }}
          />
          <label
            htmlFor={`${input.name}-check-all`}
            className="form-check-label fw-bold"
          >
            Check All
          </label>
        </div>
      )}

      {/* Individual checkboxes */}
      {input.dynamic_options &&
        input.dynamic_options.map((option, index) => (
          <div
            className="form-check form-check-inline"
            key={index}
          >
            <input
              type="checkbox"
              className="form-check-input"
              id={`${input.name}-${index}`}
              name={input.name}
              value={option.id}
              checked={values[input.name]?.includes(option.id)}
              onChange={(e) => {
                const isChecked = e.target.checked;
                const value = option.id;
                const currentValues = values[input.name] || [];
                const updatedValues = isChecked
                  ? [...currentValues, value]
                  : currentValues.filter((v) => v !== value);

                handleChange({
                  target: {
                    name: input.name,
                    value: updatedValues,
                  },
                });
              }}
            />
            <label
              htmlFor={`${input.name}-${index}`}
              className="form-check-label"
            >
              {option.name}
            </label>
          </div>
        ))}
    </>
  );

                            case 'hidden-user':
                              return (
                                <input
                                  type="hidden"
                                  id={input.name}
                                  name={input.name}
                                  value="0"
                                  required={input.is_required}
                                />
                              );
                            case 'hidden-branch':
                              return (
                                <input
                                  type="hidden"
                                  id={input.name}
                                  name={input.name}
                                  value="0"
                                  required={input.is_required}
                                />
                              );

                            case 'textarea':
                              return (
                                <textarea
                                  className="form-control"
                                  id={input.name}
                                  name={input.name}
                                  rows="3"
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                ></textarea>
                              );
                            case 'file':
                              return (
                                <>
                                  <input
                                    title="file"
                                    type={input.type}
                                    className="form-control"
                                    id={input.name}
                                    name={input.name}
                                    placeholder={input.placeholder}
                                    onChange={handleFileChange}
                                    required={input.is_required}
                                    accept={input.allowed_extensions} // Restricts file type selection in the browser
                                  />
                                  <p className="text-danger">
                                    Only allowed files: '
                                    {input.allowed_extensions}', Max size:{' '}
                                    {input.max_size_mb}MB
                                  </p>
                                </>
                              );
                            case 'multi-file':
                              return (
                                <>
                                  <input
                                    title="file"
                                    type="file"
                                    multiple
                                    className="form-control"
                                    id={input.name}
                                    name={input.name}
                                    placeholder={input.placeholder}
                                    onChange={handleMultiFileChange}
                                    required={input.is_required}
                                    accept={input.allowed_extensions} // Restricts file type selection in the browser
                                  />
                                  <p className="text-danger">
                                    Only allowed files: '
                                    {input.allowed_extensions}', Max size:{' '}
                                    {input.max_size_mb}MB
                                  </p>
                                </>
                              );
                            case 'today-date':
                              return (
                                <>
                                  <input
                                    title="Today date, can't change the date"
                                    type={input.type}
                                    className="form-control"
                                    id={input.name}
                                    name={input.name}
                                    placeholder={input.placeholder}
                                    value={values[input.name]}
                                    onChange={handleChange}
                                    required={input.is_required}
                                    readOnly={input.is_readonly} // Conditionally apply readOnly
                                  />
                                </>
                              );
                            default:
                               if (input.name=='parent') {
                                 return (
                                <>
                                  <input
                                    type={'button'}
                                    className="form-control"
                                    id={input.name}

                                    name={input.name}
                                    onClick={(e)=>{
                                      const [text,value]=e.target.value.split(':');
                                     setHvInputsValues((prev) => ({ ...prev, parent_id: value,text }));

                                     onRequestClose(true);

                                        navigate('multi-entry2/student-receipt-by-parent')
                                      
                                    }}
                                    placeholder={input.placeholder}
                                    value={values[input.name]}
                                    onChange={handleChange}
                                    required={input.is_required}
                                    readOnly={input.is_readonly} // Conditionally apply readOnly
                                  />
                                </>
                              );
                              }
                              else
                             {
                               return (
                                <>
                                  <input
                                    type={input.type}
                                    className="form-control"
                                    id={input.name}
                                    name={input.name}
                                    
                                    placeholder={input.placeholder}
                                    value={values[input.name]}
                                    onChange={handleChange}
                                    required={input.is_required}
                                    readOnly={input.is_readonly} // Conditionally apply readOnly
                                  />
                                </>
                              );
                             }
                          }
                        })()}
                        {input.help && (
                          <p style={{ margin: 0, padding: 0, color: 'red' }}>
                            {input.help}
                          </p>
                        )}
                      </div>
                    );
                  })}
                <div className="d-flex justify-content-end align-items-center">
                  <label className="form-check-label fs-4">
                    <input
                      type="checkbox"
                      name="clearAfterSubmit"
                      checked={values.clearAfterSubmit}
                      onChange={handleChange}
                      className="form-check-input form-check-lg"
                    />
                    &nbsp;Clear after submit
                  </label>
                </div>

                {/* Your button with loading/disabled logic */}
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading
                    ? 'Uploading...' // show loading text
                    : link.button
                      ? link.button
                      : 'Submit'}
                </button>
                {progress > 0 && (
                  <div style={{ marginTop: 20 }}>
                    <div
                      style={{
                        width: '100%',
                        background: '#eee',
                        height: 20,
                        borderRadius: 5,
                      }}
                    >
                      <div
                        style={{
                          width: `${progress}%`,
                          background: 'green',
                          height: '100%',
                          borderRadius: 5,
                          transition: 'width 0.3s',
                        }}
                      />
                    </div>
                    <p>{progress}%</p>
                  </div>
                )}
                {message.success == 0 && (
                  <div className="alert alert-danger" role="alert">
                    {message.message}
                  </div>
                )}
                {message.success == 1 && (
                  <div className="alert alert-success" role="alert">
                    {message.message}
                    {message.insertId && message.print_route && (
                      <a
                        href={`/${message.print_route}/${message.insertId}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        &nbsp;Print
                      </a>
                    )}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptForm;
